import React from "react";
import { observer } from "mobx-react";

import { EventBetsViewState } from "@state/stores/my-bets/MyBetsViewStore";
import BetItem from "@features/my-bets/desktop/my-bets-page/body/list/item/BetItem";
import { PagerWrapper } from "./PagerWrapper";

export const MyBetsBetsList = observer(function MyBetsBetsList(props: {
	eventBetsState: EventBetsViewState;
}) {
	return (
		<>
			{props.eventBetsState.bets.map(
				(bet) =>
					!bet.isRemoved && (
						<BetItem key={bet.id} bet={bet} isMyBetsTab />
					)
			)}
			<PagerWrapper eventBetsState={props.eventBetsState} />
		</>
	);
});
